import React, { useState } from 'react';

export const TwitterIcon: React.FC = (): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const fillCol = hover ? '#77A3F9' : '#29335C';

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <circle cx="9" cy="9" r="9" fill="#F7F9FD" />
      <path
        d="M5.00896 12.093C5.99535 12.1948 6.88299 11.9254 7.69203 11.2733C6.83865 11.1815 6.27749 10.7212 5.98908 9.8611H6.77282V9.82758C5.83927 9.56208 5.3173 8.67921 5.35985 7.81298C5.48032 7.86755 5.59698 7.93068 5.7197 7.9735C5.84316 8.01353 5.96966 8.04137 6.09768 8.0567C5.31596 7.28296 5.17198 6.38761 5.61423 5.34691C6.60062 6.72701 8.27334 7.48924 9.40237 7.45401C9.38804 7.32456 9.35758 7.19536 9.36229 7.06714C9.37706 6.54495 9.51097 6.0744 9.84261 5.67481C10.1411 5.3151 10.5045 5.09487 10.9338 5.02464C11.4582 4.939 11.9415 5.07701 12.3683 5.43231C12.3906 5.45164 12.4258 5.46143 12.4392 5.4859C12.5416 5.6753 12.6842 5.61852 12.8304 5.57228C13.1269 5.47831 13.4126 5.35768 13.6771 5.18198C13.6957 5.16975 13.7167 5.16192 13.7526 5.14405C13.6294 5.6058 13.3853 5.9545 13.0423 6.23443C13.3703 6.19675 13.6787 6.09226 14 5.96844C13.9351 6.06632 13.8764 6.17105 13.8041 6.26208C13.6921 6.40254 13.5739 6.53614 13.4541 6.66852C13.3791 6.75148 13.3063 6.84495 13.2154 6.90074C13.0904 6.97733 13.0586 7.07766 13.0689 7.22301C13.1007 7.69406 13.0398 8.15874 12.9346 8.61192C12.8571 8.94642 12.7373 9.26991 12.6238 9.59291C12.4932 9.96437 12.3042 10.3025 12.0962 10.628C11.8101 11.0708 11.4691 11.4682 11.0832 11.8087C10.7581 12.096 10.3999 12.3353 10.0177 12.5205C9.66627 12.6956 9.29594 12.8214 8.91556 12.8949C8.63811 12.9475 8.36224 13.0006 8.07808 12.9908C7.83624 12.9822 7.59193 13.0153 7.35211 12.9908C6.8176 12.9362 6.2963 12.8051 5.80322 12.5675C5.5307 12.4361 5.26737 12.2817 5 12.1375L5.00896 12.093Z"
        fill={fillCol}
      />
    </svg>
  );
};
